module.exports = __webpack_public_path__ + "static/AvenirNext-UltraLight-920b9e91fda4c1388aa265ada4b1c3dd.woff";